import { ShakaPlayerAdapter } from '../shakaPlayer/internal/ShakaPlayerAdapter';
import { ExternalPlayer } from '../ExternalPlayer';
import { PlayerAdapter } from './PlayerAdapter';
import { WebMAFAdapter } from '../webmaf/internal/WebMafPlayerAdapter';
import { PlayerBuilder } from '../PlayerBuilder';
import { WebMafPlayerBuilder } from '../internal/CoreWebMafPlayerBuilder';
import { UVPPlayerAdapter } from './UVPPlayer/internal/UVPPlayerAdapter';
import { UVPPlayerBuilder } from './CoreUVPPlayerBuilder';
import { JanusPlayerAdapter } from './JanusPlayer/internal/JanusPlayerAdapter';
import { JanusPlayerBuilder } from './CoreJanusPlayerBuilder';
import { ThumbnailPreviewImpl } from '../thumbnailPreview/internal/ThumbnailPreviewImpl';
import { ThumbnailPreviewConfig } from '../thumbnailPreview/ThumbnailPreviewConfiguration';

export const Factory = {
  createPlayerAdapter(builder: PlayerBuilder): PlayerAdapter {
    switch (builder.extPlayer) {
      case ExternalPlayer.UVPPlayer: {
        const uvpBuilder = builder as UVPPlayerBuilder;
        return new UVPPlayerAdapter(
          uvpBuilder.sceUvp,
          uvpBuilder.videoWrapper,
          uvpBuilder.configuredLogger,
          uvpBuilder.contentUrl,
          uvpBuilder.options,
          uvpBuilder.licenseUrl,
          '',
          uvpBuilder.drmType,
          uvpBuilder.mediaFormatType,
        );
      }
      case ExternalPlayer.WebMAF: {
        return new WebMAFAdapter(
          window,
          builder.configuredLogger,
          builder.contentUrl,
          builder.options,
          builder.licenseUrl,
          (builder as WebMafPlayerBuilder).drmLicenseCustomData,
          builder.drmType,
          builder.mediaFormatType,
        );
      }
      case ExternalPlayer.JanusPlayer: {
        const janusBuilder = builder as JanusPlayerBuilder;
        return new JanusPlayerAdapter(
          janusBuilder.videoElement,
          janusBuilder.janusConfig,
          janusBuilder.options,
          janusBuilder.configuredLogger,
        );
      }
      case ExternalPlayer.ShakaPlayer:
      default: {
        if (!builder.videoElement) {
          throw new Error('Missing video element');
        }

        return new ShakaPlayerAdapter(
          builder.videoElement,
          builder.configuredLogger,
          builder.contentUrl,
          builder.options,
          builder.licenseUrl,
          builder.drmType,
          builder.mediaFormatType,
          builder.serverCertificate,
          builder.getSideLoadedTracks,
          builder.videoWrapper,
          builder.library,
          builder.webVTTThumbnailPreviewEndpointUrl,
          undefined,
          builder.externalShakaPlayer,
        );
      }
    }
  },
};

export function createThumbnailPreview(
  thumbnailPreviewEndpointUrl: string | undefined,
  config: ThumbnailPreviewConfig,
): ThumbnailPreviewImpl | undefined {
  if (!thumbnailPreviewEndpointUrl) return undefined;
  return new ThumbnailPreviewImpl(thumbnailPreviewEndpointUrl, config);
}
